export default function topTitleAnimation() {
    const titles = document.querySelectorAll('.js-section-title');

    // 監視設定（画面の下から25%の位置に入った時に発火 = top 75%相当）
    const observerOptions = {
        root: null,
        rootMargin: '0px 0px -25% 0px',
        threshold: 0
    };

    titles.forEach(title => {
        const main = title.querySelector('.js-section-title-main');
        const sub = title.querySelector('.js-section-title-sub');
        const mainText = main.textContent;
        const subText = sub.textContent;

        main.textContent = '';
        sub.textContent = '';

        const mainChars = mainText.split('').map(char => {
            const span = document.createElement('span');
            span.className = 'char';
            span.textContent = char;
            main.insertAdjacentElement('beforeend', span);
            return span;
        });

        const subChars = subText.split('').map(char => {
            const span = document.createElement('span');
            span.className = 'char';
            span.textContent = char;
            sub.insertAdjacentElement('beforeend', span);
            return span;
        });


        gsap.set([title], {
            opacity: 1
        });

        const tl = gsap.timeline({
            paused: true
        });

        tl.from(mainChars, {
            opacity: 0,
            y: 30,
            duration: 0.5,
            stagger: 0.05,
            ease: 'power2.out',
        })
            .from(subChars, {
                opacity: 0,
                y: 30,
                duration: 0.5,
                stagger: 0.05,
                ease: 'power2.out',
            }, 0);

        // IntersectionObserverによる表示判定
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    tl.play();
                    observer.unobserve(entry.target); // 一度再生したら監視を停止
                }
            });
        }, observerOptions);

        observer.observe(title);
    });
}